import React from "react";
import { Link } from "react-router-dom";
import LoadJquery from "../helper/LoadJquery";
import AboutUsSection from "../components/Digital_Marketing_Components/About2";
import ProcessSection from "../components/Digital_Marketing_Components/Process";
import Services from "../components/Digital_Marketing_Components/Services";
import SuccessStories from "../components/Digital_Marketing_Components/SuccessStories";
import WhyChooseUsSection from "../components/Digital_Marketing_Components/WhyChooseUs3";
import DigitalMarketingSection from "../components/Digital_Marketing_Components/WhyNeeds";
import VisitorTracker from '../components/VisitorTracker';
import useContactForm from '../hooks/useContactForm';

const Marketing_Demo = () => {
  // Validation, submit guarding, per-field errors and form analytics all
  // live in the shared hook. The source page name is what lets the admin
  // console attribute this lead to the right page.
  const {
    formData, errors, isLoading, handleSubmit, handleInputChange, fieldProps,
  } = useContactForm("digital-marketing");

  // Renders the message under a field, and nothing when it is valid.
  const Err = ({ name }) =>
    errors[name] ? (
      <p className="form-field-error" id={`${name}-error`} role="alert">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />{" "}
        {errors[name]}
      </p>
    ) : null;
  return (
    <>
      <div>
        <LoadJquery />
        <VisitorTracker page="digital-marketing" />
        {/* <!-- tpm-header-area start --> */}
        {/* <!-- tpm-header-area start --> */}
  
        {/* <!-- tpm-header-area end --> */}

        {/* <!-- Start swiper slider area  --> */}
        <div className="tmp-banner-area banner-three bg_image tmp-section-gap">
          <div className="swiper-container-three">
            {/* <!-- swiper slides --> */}
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="slider-inner">
                  <div className="thumbnail">
                    <img
                      src="assets/images/banner/banner-three.jpg"
                      alt="marketing consulting"
                    />
                  </div>
                  <div className="content">
                    <h2 className="title">
                      Start your upcoming modern consulting
                    </h2>
                    <p className="description">
                      We help small startups grow from idea to millions of
                      users. we can also automate your marketing and customer
                      service.
                    </p>
                    <div
                      className="banner-bottom justify-content-center"
                      style={{ gap: "30px" }}
                    >
                      {/*<Link to="/service" className="tmp-btn btn-gradiant">
                        Get Started Now
                      </Link>*/}
                      <Link to="/contact" className="tmp-btn btn-gradiant-2">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="swiper-slide">
                <div className="slider-inner">
                  <div className="thumbnail">
                    <img
                      src="assets/images/banner/banner-four.jpg"
                      alt="marketing consulting"
                    />
                  </div>
                  <div className="content">
                    <h2 className="title">
                      Start your upcoming modern consulting
                    </h2>
                    <p className="description">
                      We help small startups grow from idea to millions of
                      users. we can also automate your marketing and customer
                      service.
                    </p>
                    <div
                      className="banner-bottom justify-content-center"
                      style={{ gap: "30px" }}
                    >
                      {/*<Link to="/service" className="tmp-btn btn-gradiant">
                        Get Started Now
                      </Link>*/}
                      <Link to="/contact" className="tmp-btn btn-gradiant-2">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="swiper-slide">
                <div className="slider-inner">
                  <div className="thumbnail">
                    <img
                      src="assets/images/banner/banner-five.jpg"
                      alt="marketing consulting"
                    />
                  </div>
                  <div className="content">
                    <h2 className="title">
                      Marketing Consulting Help Your Business
                    </h2>
                    <p className="description">
                      We help small startups grow from idea to millions of
                      users. we can also automate your marketing and customer
                      service.
                    </p>
                    <div
                      className="banner-bottom justify-content-center"
                      style={{ gap: "30px" }}
                    >
                      {/*<Link to="/service" className="tmp-btn btn-gradiant">
                        Get Started Now
                      </Link>*/}
                      <Link to="/contact" className="tmp-btn btn-gradiant-2">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- !swiper slides --> */}

            {/* <!-- next prev arrows --> */}
            <div className="swiper-button-next">
              <i className="fa-regular fa-angle-right"></i>
            </div>
            <div className="swiper-button-prev">
              <i className="fa-regular fa-angle-left"></i>
            </div>
            {/* <!-- next prev arrows --> */}

            {/* <!-- pagination dots --> */}
            <div className="swiper-pagination"></div>
            {/* <!-- !pagination dots --> */}
          </div>
        </div>
        {/* <!-- End swiper slider area  --> */}



<AboutUsSection/>
<ProcessSection/>
<Services/>
<SuccessStories/>
<DigitalMarketingSection/>
    

        {/* <!-- Start Contact Area  --> */}
        <div className="contact-area-three tmp-section-gap">
          <div className="bg-shape">
            <img src="assets/images/cta/02.png" alt="bussiness-contact" />
          </div>
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-5">
                <div className="contact-inner">
                  <div
                    className="section-head section-head-one-side text-align-left"
                    data-sal-delay="150"
                    data-sal="slide-up"
                    data-sal-duration="800"
                  >
                    <span className="title">Contact Us</span>
                    <p className="description">
                    Have questions or ready to get started? Reach out to our team—we're here to help you grow and succeed.
                    </p>
                  </div>

                  <ul
                    className="ft-link ft-link-style-three"
                    data-sal-delay="250"
                    data-sal="slide-up"
                    data-sal-duration="800"
                  >
                    <li>
                      <div className="single-contact background-transparent">
                        <div className="icon">
                          <i className="fa-light fa-phone"></i>
                        </div>
                        <div className="content">
                          <span>Call Us</span>
                          <Link className="contact-here" to="#">
                           +919057000445   |   +919057000446`
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact background-transparent">
                        <div className="icon">
                          <i className="fa-solid fa-envelope-open-text"></i>
                        </div>

                        <div className="content">
                          <span>E-mail</span>
                          <Link className="contact-here" to="#">
                           info@starparth.com
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact background-transparent">
                        <div className="icon">
                          <i className="fa-solid fa-map-location-dot"></i>
                        </div>
                        <div className="content">
                          <span>Address</span>
                          <Link className="contact-here" to="#">
                           G2 Aanchal Apartment 1/55 Roshan Marg
                            Chitrakoot Jaipur Rajasthan 302021
                          </Link>
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div
                    className="tmp-tag-list tag-list-one"
                    data-sal-delay="350"
                    data-sal="slide-up"
                    data-sal-duration="800"
                  >
                    <Link className="tag-list" to="https://www.facebook.com/starparthexamination/">
                      Facebook
                    </Link>
                    <Link className="tag-list" to="https://x.com/Starparthtech">
                      Twitter
                    </Link>
                    <Link className="tag-list" to="#">
                      Linkedin
                    </Link>
                    <Link className="tag-list" to="#">
                      Skype
                    </Link>
                    <Link className="tag-list" to="#">
                      Pinterest
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-7"
                data-sal-delay="150"
                data-sal="slide-up"
                data-sal-duration="800"
              >
                <div className="contact-inner">
                  <div className="section-head section-head-one-side text-align-left">
                    <span className="title">GET IN TOUCH</span>
                    <p className="description">
                   Let’s connect and explore how Starparth can bring your vision to life
                    </p>
                  </div>
                  <div className="contact-form style-two">
                    <form id="contact-form" onSubmit={handleSubmit} noValidate>
                      <div className="contact-form-wrapper row">
                        {/* Bots fill every field they find; people never see this. */}
                        <div className="form-honeypot" aria-hidden="true">
                          <input type="text" name="company_website" tabIndex={-1}
                            autoComplete="off" {...fieldProps("company_website")} />
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              name="name"
                              placeholder="Name"
                              id="contact-name"
                              type="text"
                              value={formData.name}
	                            onChange={handleInputChange}
                              required
                            />
                            <Err name="name" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              name="phone"
                              placeholder="Phone"
                              type="text"
                              value={formData.phone}
                              onChange={handleInputChange}
                              required
                            />
                            <Err name="phone" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              name="email"
                              placeholder="Email"
                              type="email"
                              value={formData.email}
	                            onChange={handleInputChange}
                              required
                            />
                            <Err name="email" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              type="text"
                              id="subject"
                              placeholder="Website"
                              name="website"
                          	  value={formData.website}
	                            onChange={handleInputChange}
                            />
                            <Err name="website" />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <textarea
                              className="input-field"
                              placeholder="How can we help"
                              name="message"
                              id="contact-message"
                              value={formData.message}
	                            onChange={handleInputChange}
                            ></textarea>
                            <Err name="message" />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-submit-group">
                            <button
                              name="submit"
                              className="tmp-btn btn-gradiant-two"
                              type="submit"
                              id="submit"
	                            disabled={isLoading}
                            >
                              {isLoading ? 'Sending…' : 'Submit Now'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Contact Area  --> */}


<WhyChooseUsSection/>


        {/* <!-- Start Footer Area  --> */}
        {/* <!-- Start Footer Area  --> */}
        {/* <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="subscribe-area subscribe-style-1">
                  <div className="subscribe-inner">
                    <div className="title">Subscribe to Newsletter</div>
                    <form action="#" className="newsletter-form-1 mt--40">
                      <input type="email" placeholder="Your Email" required />
                      <button type="submit" className="tmp-btn btn-primary">
                        Subscribe Now{" "}
                        <i className="fa-sharp fa-regular fa-paper-plane"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-main footer-style-one">
              <div className="row g-5">
                <div className="col-lg-4 col-md-6">
                  <div className="single-footer-wrapper border-right mr--20">
                    <div className="logo">
                      <Link to="/">
                        <img src="assets/images/logo/logo-02.svg" alt="logo" />
                        <img height="61" width="188" src="/assets/images/logo/starpath-logo.svg" alt="logo" />
                      </Link>
                    </div>

                    <p className="description">
                      Proin Pretium Sem Libero, Nec Aliquet Augue Lobortis In.
                      Phasellus Nibh Quam, Molestie Id Est Sit Amet, Luctus
                      Pulvinar
                    </p>

                    <div className="day-time">
                      <div className="icon">
                        <i className="fa-solid fa-alarm-clock"></i>
                      </div>
                      <div className="content">
                        <div className="day">Sunday - Friday:</div>
                        <div className="time">9:00 AM – 8:00 PM</div>
                      </div>
                    </div>

                    <ul className="social-icons solid-social-icons rounded-social-icons">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-instagram"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6">
                  <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                    <h5 className="ft-title">Quick Link</h5>
                    <ul className="ft-link">
                      <li>
                        <Link to="/about">About Company</Link>
                      </li>
                      <li>
                        <Link to="/team"> Our Team</Link>
                      </li>
                      <li>
                        <Link to="/service">Our Services</Link>
                      </li>
                      <li>
                        <Link to="/blog">News & Media</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>

                      <li>
                        <Link to="/faq">Support</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="single-footer-wrapper pr--15">
                    <h5 className="ft-title">Recent Post</h5>

                    <div className="single-post">
                      <div className="thumbnail">
                        <img
                          src="assets/images/footer/small-post.jpg"
                          alt="Business_Corporate"
                        />
                      </div>
                      <div className="content">
                        <div className="date">
                          <i className="fa-light fa-calendar-days"></i>
                          <span>12 Feb, 2022</span>
                        </div>

                        <Link to="/blog/details">
                          <h6 className="title">
                            Day tree hide from hath gathered multy
                          </h6>
                        </Link>
                      </div>
                    </div>

                    <div className="single-post">
                      <div className="thumbnail">
                        <img
                          src="assets/images/footer/small-post-2.jpg"
                          alt="Business_Corporate"
                        />
                      </div>
                      <div className="content">
                        <div className="date">
                          <i className="fa-light fa-calendar-days"></i>
                          <span>12 Feb, 2022</span>
                        </div>

                        <Link to="/blog/details">
                          <h6 className="title">
                            Saving Time Achieving Success in Business
                          </h6>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="single-footer-wrapper">
                    <h5 className="ft-title">Official info:</h5>
                    <ul className="ft-link">
                      <li className="ft-location">
                        5919 Trussville Crossings Pkwy, new Dusting town,
                        Austria
                      </li>

                      <li>
                        <div className="single-contact">
                          <div className="icon">
                            <i className="fa-solid fa-envelope-open-text"></i>
                          </div>

                          <div className="content">
                            <span>E-mail:</span>
                            <Link to="mailto:webmaster@example.com">
                              info@uibundle.com
                            </Link>
                          </div>
                        </div>
                      </li>

                      <li>
                        <div className="single-contact">
                          <div className="icon">
                            <i className="fa-light fa-phone"></i>
                          </div>
                          <div className="content">
                            <span>Phone:</span>
                            <Link to="tel:+4733378901">+123 34598768</Link>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="copyright-area-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="main-wrapper">
                  <p>
                    © Copyright 2024. All Rights Reserved by{" "}
                    <Link to="#">Themes-Park</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <!-- End Footer Area  --> */}
        {/* <!-- End Footer Area  --> */}

        <div
          id="overlay_every-where"
          data-tmp-cursor="md text-black dark:text-white opacity-10"
          data-tmp-cursor-icon="fa-regular fa-x fa-fw"
        ></div>

        {/* <!-- progress area start --> */}
        <div className="progress-wrap">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
        {/* <!-- progress area end --> */}

        {/* <!-- ==================== Start Loading ==================== --> */}
{/* 
        <div className="loader-wrap">
          <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
            <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
          </svg>

          <div className="loader-wrap-heading">
            <div className="load-text">
              <span>L</span>
              <span>o</span>
              <span>Link</span>
              <span>d</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
            </div>
          </div>
        </div> */}

        {/* <!-- ==================== End Loading ==================== --> */}
      </div>
    </>
  );
};

export default Marketing_Demo;
